import React, { useState } from 'react';
import AppLogo from '../../components/common/AppLogo';
import { useNavigate, Link } from "react-router-dom";
import ValidateEmail from '../../components/common/ValidateEmail';
import { Auth } from 'aws-amplify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { Image } from "primereact/image";
import loginPage from "../../assets/images/login-page.svg";


export default function ForgotPassword() {

    let navigateTo = useNavigate();
    const [email, setEmail] = useState("");
    const [showPleaseWaitButton, setPleaseWaitButton] = useState(false);

    async function resetPassword(event) {
        event.preventDefault();
        if (email === "") { toast.error('Enter Email.'); return; }
        if (!ValidateEmail(email)) { toast.error('Invalid email.'); return; }

        //Send confirmation code to user's email
        setPleaseWaitButton(true)
        Auth.forgotPassword(email)
            .then(data => {
                if (data) {
                    toast.success("Verification code sent to your Email!")
                    setPleaseWaitButton(false)
                    navigateTo("/resetpassword", { state: { email: email } })
                }
            }).catch(e => {
                setPleaseWaitButton(false)
                switch (e.message) {
                    case 'Cannot reset password for the user as there is no registered/verified email or phone_number.':
                        toast.error("User Account Not Found");
                        break;
                    default:
                        toast.error("User Account Not Found");
                }
            })
    }
    return (
        <div className="login overflow-auto min-h-screen flex-row align-center grid 2xl:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 sm:grid-cols-1 gap-4">
            <div className="flex flex-wrap flex-row align-center justify-center top-90 auto-rows-max" >
                <div className="max-w-md w-full p-2 mt-24">
                    <form action="#" onSubmit={resetPassword} autoComplete="off">
                        <div className="mb-10">
                            <AppLogo />
                        </div>
                        <div className="mb-2">
                            <h2 className="text-[30px] font-semibold text-[#101828] dark:text-[#FFFFFF]">Forgot Password</h2>
                        </div>

                        <div className="relative mb-6">
                            <label htmlFor="required-email" className="text-[#344054] text-[14px] font-medium dark:text-[#FFFFFF]">
                                Email
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <input onChange={(e) => setEmail(e.target.value)} value={email} type="email" id="required-email" className="text-lg rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-500 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-indigo-600 mt-2 dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]" placeholder="Enter Email" />
                        </div>
                        <div className="flex w-full mb-8">
                            <button type="submit" className="custmBtn blue radius8 w-full text-center">
                                {showPleaseWaitButton ? 'Please wait...' : 'Submit'}
                            </button>
                        </div>
                        <div className="flex align-center justify-center">
                            <Link
                                to={"/"}
                                className="dark:text-[#FFFFFF]"
                            >
                                Back to Sign in
                            </Link>
                        </div>
                    </form>
                </div>
            </div>

            <div className="flex-row flex flex-wrap align-center justify-center content-center">
            <Image
              className="relative xl:h-[31.250vw] xl:w-[36.458vw]"
              src={loginPage}
              width={"700"}
              height={"600"}
              alt="GUSD forms"
            />
                
            </div>
        </div>
    )
}